<div class="p-6">
  <p class="text-bb-text-secondary mb-4">{{ data.message }}</p>

  <div class="flex flex-col gap-2 mb-4">
    <label
      for="dialog-input"
      class="text-sm font-medium text-bb-text-primary">
      {{ data.placeholder || 'Enter value' }}
    </label>
    <input
      id="dialog-input"
      [type]="data.inputType || 'text'"
      [formControl]="inputControl"
      [maxlength]="data.maxLength || null"
      [minlength]="data.minLength || null"
      [placeholder]="data.placeholder || ''"
      (keyup.enter)="onConfirm()"
      class="block w-full px-3 py-2 text-sm rounded-md border appearance-none transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-offset-0 bg-bb-bg-secondary text-bb-text-primary placeholder:text-bb-text-muted"
      [class.border-bb-accent-red]="inputControl.invalid && inputControl.touched"
      [class.focus:border-bb-accent-red]="inputControl.invalid && inputControl.touched"
      [class.focus:ring-bb-cta-blue/20]="inputControl.invalid && inputControl.touched"
      [class.border-bb-border]="!(inputControl.invalid && inputControl.touched)"
      [class.focus:border-bb-accent-blue]="!(inputControl.invalid && inputControl.touched)"
      [class.focus:ring-bb-accent-blue/20]="!(inputControl.invalid && inputControl.touched)"
      />

      @if (inputControl.hasError('required') && inputControl.touched) {
        <small
          class="text-bb-accent-red">
          This field is required
        </small>
      }
      @if (inputControl.hasError('minlength') && inputControl.touched) {
        <small
          class="text-bb-accent-red">
          Minimum length is {{ data.minLength }} characters
        </small>
      }
      @if (inputControl.hasError('maxlength') && inputControl.touched) {
        <small
          class="text-bb-accent-red">
          Maximum length is {{ data.maxLength }} characters
        </small>
      }
      @if (inputControl.hasError('pattern') && inputControl.touched) {
        <small
          class="text-bb-accent-red">
          {{ data.patternError || 'Invalid format' }}
        </small>
      }
    </div>

    <div class="flex justify-end gap-2 pt-4 border-t border-bb-border">
      <app-button
        type="button"
        variant="ghost"
        (clicked)="onCancel()">
        Cancel
      </app-button>
      <app-button
        type="button"
        variant="primary"
        (clicked)="onConfirm()"
        [disabled]="inputControl.invalid">
        OK
      </app-button>
    </div>
  </div>
